import { MenuOptionType } from "@dexteel/mesf-core";

import { RollOperation } from "../../../models/Operation";

type Props = {
	setSelectedRowData: (universal: RollOperation) => void;
	setShowModal: (modal: "create" | "update" | "delete" | "") => void;
};
export const useOperationOptionsFunctions = ({
	setSelectedRowData,
	setShowModal,
}: Props) => {
	const getMenuOptions = (data: RollOperation) => {
		let options: MenuOptionType[] = [];
		return options;
	};
	return {
		getMenuOptions,
	};
};
